import { Typography } from '@material-ui/core';
import React from 'react';
export default function NotFound() {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: '32px 0',
      }}
    >
      <Typography variant="h1" style={{ margin: '32px 0' }}>
        404
      </Typography>
      <Typography variant="h3" style={{ margin: '0 0 32px 0' }}>
        Stránka nebyla nalezena.
      </Typography>
    </div>
  );
}
